/*
 * Copyright © 2023 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { LogLevel } from '../config/trackerConfig';

class Log {
  constructor(timestamp, message, category, data, level) {
    this.timestamp = timestamp || new Date();
    this.message = message;
    this.category = category;
    this.data = data;
    this.level = level;
  }

  static Builder = class {
    setTimestamp(timestamp) {
      this.timestamp = timestamp || new Date();
      return this;
    }

    setCategory(category) {
      this.category = category;
      return this;
    }

    setMessage(message) {
      this.message = message;
      return this;
    }

    setLevel(level) {
      this.level = level || LogLevel.INFO;
      return this;
    }

    setData(data) {
      this.data = data;
      return this;
    }

    build() {
      return new Log(this.timestamp, this.message, this.category, this.data, this.level || LogLevel.INFO);
    }
  };
}

export default Log;
